import Vue from "vue";
import Vuex from "vuex";
import "es6-promise/auto";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    raceStatsIndex: undefined,
    punterData: undefined,
    userAuthToken: undefined,
    selectedHorse: undefined,
    selectedTrainer: undefined,
    selectedJockey: undefined,
    selectedBreeder: undefined,
    selectedRaceCard: undefined,
    selectedRace: undefined,
    selectedFormGrid: undefined,
    selectedRaceCardSummary: undefined,
    selectedRaceStats: undefined,
    isLoading: false,
    isFormGridOpen: false,
    selectedFormGridHorseIndex: undefined,
    selectedRaceCardHorseIndex: undefined,
    nationalStatistics: undefined,
    raceCardDateToggleAscending: true,
    raceReportData: undefined,
    reportRaceNumber: undefined,
    reportSectional: undefined,
    reportSectionalRaceNumber: undefined,
    reportName: undefined,
    sectionalReportHeaderNames: undefined,
    positionBehindLeadHorseData: undefined,
    positionBehindLeadHorseRaceNumber: undefined,
    postionAndMarginBehindData: undefined,
    reportDate: undefined,
    reportRacecourse: undefined,
    reportRacesDisplayArray: undefined,
    raceCardBanners: undefined,
  },
  mutations: {
    setReportRacesArray(state, reportRacesArray) {
      state.reportRacesDisplayArray = reportRacesArray;
    },
    setReportDate(state, reportDate) {
      state.reportDate = reportDate;
    },
    setReportRacecourse(state, reportRacecourse) {
      state.reportRacecourse = reportRacecourse;
    },
    setPositionBehindLeadHorse(state, posBehindData) {
      state.positionBehindLeadHorseData = posBehindData;
    },
    setPostionAndMarginBehindData(state, data) {
      state.postionAndMarginBehindData = data;
    },
    setPositonBehindLeaderHorseRaceNumber(state, rn) {
      state.positionBehindLeadHorseRaceNumber = rn;
    },
    setReportHeaderNames(state, rhNames) {
      state.sectionalReportHeaderNames = rhNames;
    },
    setReportName(state, repName) {
      state.reportName = repName;
    },
    setReportSectioanl(state, sect) {
      state.reportSectional = sect;
    },
    setReportRN(state, rn) {
      state.reportSectionalRaceNumber = rn;
    },
    setRaceStatsIndex(state, raceStatsIndex) {
      state.raceStatsIndex = raceStatsIndex;
    },
    setPunterData(state, punterData) {
      state.punterData = punterData;
    },
    setUserAuthToken(state, userAuthToken) {
      state.userAuthToken = userAuthToken;
    },
    setSelectedHorse(state, selectedHorse) {
      state.selectedHorse = selectedHorse;
      state.selectedTrainer = undefined;
      state.selectedJockey = undefined;
      state.selectedBreeder = undefined;
    },
    setSelectedTrainer(state, selectedTrainer) {
      state.selectedTrainer = selectedTrainer;
      state.selectedHorse = undefined;
      state.selectedJockey = undefined;
      state.selectedBreeder = undefined;
    },
    setSelectedJockey(state, selectedJockey) {
      state.selectedJockey = selectedJockey;
      state.selectedHorse = undefined;
      state.selectedTrainer = undefined;
      state.selectedBreeder = undefined;
    },
    setSelectedBreeder(state, selectedBreeder) {
      state.selectedBreeder = selectedBreeder;
      state.selectedHorse = undefined;
      state.selectedTrainer = undefined;
      state.selectedJockey = undefined;
    },
    setSelectedRace(state, selectedRace) {
      state.selectedRace = selectedRace;
    },
    setSelectedRaceCard(state, selectedRaceCard) {
      state.selectedRaceCard = selectedRaceCard;
    },
    setSelectedFormGrid(state, selectedFormGrid) {
      state.selectedFormGrid = selectedFormGrid;
    },
    setSelectedRaceStats(state, selectedRaceStats) {
      state.selectedRaceStats = selectedRaceStats;
    },
    setIsLoading(state, isLoading) {
      state.isLoading = isLoading;
    },
    setIsFormGridOpen(state, isFormGridOpen) {
      state.isFormGridOpen = isFormGridOpen;
    },
    setSelectedFormGridHorseIndex(state, selectedFormGridHorseIndex) {
      state.selectedFormGridHorseIndex = selectedFormGridHorseIndex;
    },
    setSelectedRaceCardSummary(state, selectedRaceCardSummary) {
      state.selectedRaceCardSummary = selectedRaceCardSummary;
    },
    setSelectedRaceCardHorseIndex(state, selectedRaceCardHorseIndex) {
      state.selectedRaceCardHorseIndex = selectedRaceCardHorseIndex;
    },
    setNationalStatistics(state, nationalStatistics) {
      state.nationalStatistics = nationalStatistics;
    },
    setRaceCardDateToggleAscending(state, raceCardDateToggleAscending) {
      state.raceCardDateToggleAscending = raceCardDateToggleAscending;
    },
    setRaceReportData(state, raceReportData) {
      state.raceReportData = raceReportData;
    },
    setReportRaceNumber(state, raceReportNumber) {
      state.reportRaceNumber = raceReportNumber;
    },
    setRaceCardBanners(state, banners) {
      state.raceCardBanners = banners;
    },
  },
  getters: {
    getAllRaceCardSummaries(state) {
      return state.raceCard;
    },
    getRaceNumber(state) {
      return state.reportRaceNumber;
    },
    getUserAuthToken(state) {
      return state.userAuthToken;
    },
    getSelectedHorse(state) {
      return state.selectedHorse;
    },
    getSelectedTrainer(state) {
      return state.selectedTrainer;
    },
    getSelectedJockey(state) {
      return state.selectedJockey;
    },
    getSelectedBreeder(state) {
      return state.selectedBreeder;
    },
    getRaceDataForReport(state) {
      return state.raceReportData.filter(
        (a) => a.raceNumber == state.reportRaceNumber,
      );
    },
    getReportSectional(state) {
      if (!state.reportSectional) {
        return [];
      }

      if (Array.isArray(state.reportSectional)) {
        return state.reportSectional.filter(
          (a) => a.race == state.reportSectionalRaceNumber,
        );
      }

      return state.reportSectional;
    },
    getReportSectionalHeaders(state) {
      return state.sectionalReportHeaderNames.filter(
        (a) => a.raceNumber == state.reportSectionalRaceNumber,
      );
    },
    getReportName(state) {
      return state.reportName;
    },
    getReportPostionBehindData(state) {
      return state.positionBehindLeadHorseData;
    },
    getPositionAndMarginBehindData(state) {
      return state.postionAndMarginBehindData;
    },
    getReportRaceDate(state) {
      return state.reportDate;
    },
    getReportRacecourse(state) {
      return state.reportRacecourse;
    },
    getReportRacesArray(state) {
      return state.reportRacesDisplayArray;
    },
    getRaceCardBanners(state) {
      return state.raceCardBanners;
    },
  },
});
